import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment';
import {getBillPaymentStatusIcon, getReasonDescription} from "../BillPayment/utils/utilsBillPayment"
import {getTableRowClass,formatAsMoney,
        getAnalysisStatusColor, getAnalysisStatusSiglum,
        getAnalysisStatus} from "../BillPayment/utils/utils"
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  blueText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82"
},
redText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#D91A1A"
},
  tableText: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    lineHeight: "16px",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  }
}));

function BillPaymentTable(props) {
    const classes = useStyles();
    useTheme();

    const {alert_triggers_transactions} = props

    return (
        <Paper className={classes.tableStyle}>
            <Table style={{ padding: "8px" }}>
                <TableHead>
                <TableRow>
                    <TableCell className={classes.tableHeader}>ID</TableCell>
                    <TableCell className={classes.tableHeader}>Valor</TableCell>
                    <TableCell className={classes.tableHeader}>Status de Fraude</TableCell>
                    <TableCell className={classes.tableHeader}>Data</TableCell>
                    <TableCell className={classes.tableHeader}>Status do Pagamento</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    {props.historic.map((billPayment,index) => (
                    <TableRow
                        key={index}
                        className={getTableRowClass(index)}
                    > 
                        <TableCell
                            className={[classes.tableText, classes.blueText, "breakWord", "link"].join(" ")}
                        >
                            <Link
                                className={
                                    alert_triggers_transactions ?
                                    alert_triggers_transactions.filter((item) => item === billPayment.bill_payment_key).length ?
                                    "linkRed" :
                                    "link" :
                                    "link"
                                }
                                to={"/bill-payment/" + billPayment.bill_payment_key}
                            >
                                {alert_triggers_transactions ?
                                alert_triggers_transactions.filter((item) => item === billPayment.bill_payment_key).length ? 
                                    <Tooltip title={<p className="tooltipText">Transação responsável por um trigger</p>}>
                                        <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
                                            <ErrorOutlineIcon style={{color:"#D91A1A", width:"18px", marginRight: "5px"}}/>
                                            {billPayment.bill_payment_key}
                                        </div>
                                </Tooltip> :
                                <div>
                                    {billPayment.bill_payment_key}
                                </div> :
                                <div>
                                    {billPayment.bill_payment_key}
                                </div>
                                }
                            </Link>
                        </TableCell>
                        <TableCell className={classes.tableText}>
                            {formatAsMoney(billPayment.amount, "-")}
                        </TableCell>
                        <TableCell className={classes.tableText}>
                            <Tooltip title={<p className="tooltipText" style={{textAlign: "center"}}>
                                {getAnalysisStatus(billPayment.analysis_status)}
                                <br/>{getReasonDescription(billPayment)} 
                            </p>}>
                                <div className={["circle", "small"].join(" ")} style={{backgroundColor:getAnalysisStatusColor(billPayment.analysis_status)}}>
                                    {getAnalysisStatusSiglum(billPayment.analysis_status)}
                                </div>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={classes.tableText}>
                            {moment(billPayment.bill_payment_date).format("DD/MM/YYYY HH:mm:ss")}
                        </TableCell>
                        <TableCell className={classes.tableText}>
                            {getBillPaymentStatusIcon(billPayment.bill_payment_status, "small", true)}                            
                        </TableCell>
                        <TableCell className={classes.tableText}>

                        </TableCell>    
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    );
}

export default BillPaymentTable;
